import { useAtomValue } from 'jotai';
import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { useCallback } from 'react';

type UseSemanticUrlBuilder = () => (path: string, originalRegion?: string) => string;

export const useSemanticUrlBuilder: UseSemanticUrlBuilder = () => {
  const { region } = useAtomValue($Locale);
  const { enterHref } = useAtomValue($RootTraffic);

  return useCallback(
    (path: string, originalRegion?: string) => {
      const url = new URL(enterHref);

      if (!path.startsWith('/')) {
        console.warn('path must start with /, path: %s', path);
      }

      return `${url.protocol}//${url.host}${path}?region=${originalRegion || region}`;
    },
    [region],
  );
};
